module.exports = "This page is here for testing purpose only\n<h1 *ngIf=\"mnemonic\" data-e2e=\"decrypted-mnemonic\">{{mnemonic}}</h1>\n"